<template>
  <div class="selective-disease">
    <img src="@/assets/images/cartojourney/img01.png" class="img-bg" alt="" />
    <div class="top-con">
      <img
        src="@/assets/images/cartojourney/img03.png"
        class="con-title"
        alt=""
      />
    </div>
    <div class="con-list" v-if="diseases && diseases.length > 0">
      <div
        class="con-items"
        v-for="(item, index) in diseases"
        :key="index"
        @click="handleClickItems(item, index)"
        :class="item.check ? 'ischecked' : ''"
      >
        <template v-if="`${item.stageIndex}` === '-1'">
          <div class="items-checked">
            <img
              src="@/assets/images/cartojourney/img29.png"
              class="icon-type"
              alt=""
            />
          </div>
          <span class="items-txt">{{ item && item.diseaseName }}</span>
          <img
            src="@/assets/images/cartojourney/img05.png"
            v-if="item && item.check"
            class="icon-check"
            alt=""
          />
          <img
            src="@/assets/images/cartojourney/img06.png"
            v-else
            class="icon-check"
            alt=""
          />
        </template>
        <template v-else-if="`${item.stageIndex}` === '0'">
          <div class="items-checked items-istrue">
            <img
              src="@/assets/images/cartojourney/img30.png"
              class="icon-type"
              alt=""
            />
          </div>
          <span class="items-txt items-istrue-txt">{{ item && item.diseaseName }}</span>
          <img
            src="@/assets/images/cartojourney/img05.png"
            v-if="item && item.check"
            class="icon-check"
            alt=""
          />
          <img
            src="@/assets/images/cartojourney/img06.png"
            v-else
            class="icon-check"
            alt=""
          />
        </template>
        <template v-else-if="`${item.stageIndex}` === '1'">
          <div class="items-checked items-close">
            <img
              src="@/assets/images/cartojourney/img07.png"
              class="icon-type"
              alt=""
            />
          </div>
          <span class="items-txt">{{ item && item.diseaseName }}</span>
          <img
            src="@/assets/images/cartojourney/img05.png"
            v-if="item && item.check"
            class="icon-check"
            alt=""
          />
          <img
            src="@/assets/images/cartojourney/img06.png"
            v-else
            class="icon-check"
            alt=""
          />
        </template>
      </div>
    </div>
    <div class="submit-btn" @click="handleSubmit">下一页</div>
  </div>
</template>
<script>
import { diseaseList, customizedChangeDisease, journeyTops } from '@/api/cartoJourney.js'
import withRouteTracking from '@/utils/withRouteTracking'
import { debounce } from '@/utils/util'
const UserProfile = {
  data() {
    return {
      diseases: [],
    }
  },
  mounted() {
    this.customizedCode = this.$route.query.customizedCode
    this.customizedMultiCode = this.$route.query.customizedMultiCode
    diseaseList({ multiCode: this.customizedMultiCode }).then((res) => {
      this.diseases = res.data.map((item) => {
        item.check = false
        return item
      })
      this.handleFun()
    })
  },
  methods: {
    async handleFun() {
      let journeys = await journeyTops({customizedCode: this.customizedCode})
      let diseasesTxt = journeys.data.diseases ? journeys.data.diseases.split('；') : []
      this.diseases.map(item => {
        if (diseasesTxt.includes(item.diseaseName)) {
          item.check = true
        }
      })
    },
    handleClickItems(item, index) {
      this.diseases[index].check = !item.check
    },
    handleSubmit: debounce(function () {
      let params = {
        customizedCode: this.$route.query.customizedCode,
        diseaseNames: this.diseases
          .filter((res) => res.check)
          .map((res) => res.diseaseName),
      }
      customizedChangeDisease(params).then((res) => {
        if (res.code === 0) {
          this.$router.push({
            path: '/selectiveTechnique',
            query: {
              customizedMultiCode: this.customizedMultiCode,
              customizedCode: this.customizedCode,
            },
          })
        }
      })
    }, 500),
  },
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.selective-disease {
  min-height: 100vh;
  background-color: #f0f1f6;
  padding-bottom: 72px;
  box-sizing: border-box;
  .img-bg {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
  }
  .top-con {
    background-image: url("../../assets/images/cartojourney/img01.png");
    background-repeat: no-repeat;
    background-size: 100% auto;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 65px;
    z-index: 9;
    padding-left: 12px;
    padding-top: 27px;
    box-sizing: border-box;
    .con-title {
      width: 125px;
      display: block;
    }
  }
  .con-list {
    position: relative;
    padding: 0 12px;
    box-sizing: border-box;
    padding-top: 65px;
    z-index: 2;
    &::before {
      border-left: 2px dashed #b1b1b1;
      content: "";
      position: absolute;
      left: 34px;
      top: 75px;
      height: 80%;
    }
    .con-items {
      background-color: #fff;
      border-radius: 8px;
      display: flex;
      align-items: center;
      padding: 3px;
      box-sizing: border-box;
      margin-bottom: 16px;
      position: relative;
      padding-right: 16px;
      &.ischecked {
        border: 1px solid #000;
        box-sizing: border-box;
          .items-istrue-txt {
            color: #000000;
          }
      }
      .items-checked {
        width: 42px;
        height: 42px;
        background: rgba(122, 132, 148, 0.1);
        border-radius: 8px;
        margin-right: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        &.items-istrue {
          //background: rgba(235, 23, 0, 0.1);
        }
        &.items-close {
          background: rgba(255, 91, 12, 0.1);
        }
        .icon-type {
          width: 24px;
          display: block;
        }
      }
      .items-txt {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.35);
        flex: 1;
      }
      .icon-check {
        width: 20px;
        display: block;
      }
    }
  }
  .submit-btn {
    background-color: #eb1700;
    position: fixed;
    left: 10px;
    width: calc(100% - 20px);
    height: 42px;
    line-height: 42px;
    text-align: center;
    bottom: 15px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    border-radius: 100px;
    z-index: 9;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/cartoJourney/selectiveDisease.vue